import React, { /*useCallback,*/ useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import loadable from "@loadable/component";
import { useDispatch, useSelector } from "react-redux";
// import { useAccount } from "wagmi";
// import { useDisconnect } from 'wagmi';
import { useNavigate, useNavigationType } from "react-router-dom";

import { fetchBalanceAuthAction/*, ConnectAction*/ } from "../../redux/actions/authActions";
// import { LoadHomDataAction } from "../../redux/actions/homeActions";
import { checkGameParticipationAction, fetchGameAppDataAction } from "../../redux/actions/gameActions";
import HomeSearch from "./HomeSearch";

import { usePageMeta } from "../../utils/pageMeta";

const VideoBannerComponent = loadable(() => import("../../components/VideoBanner"));
const AllGameSectionComponent = loadable(() => import("./AllGameSectionComponent"));
const CategoriesCarousel = loadable(() => import("../categories/CategoriesCarousel"));
const EngagingLoader = loadable(() => import("../../components/UI/EngagingLoader"));
const HOME_SCROLL_Y_KEY = "akedoHomeScrollY";
const HOME_PENDING_SCROLL_RESTORE_KEY = "akedoHomePendingScrollRestore";
const HOME_SCROLL_RESTORE_MAX_ATTEMPTS = 40;
const HOME_SCROLL_RESTORE_TOLERANCE = 8;
const HOME_INITIAL_OVERLAY_MAX_MS = 2500;
const HOME_INITIAL_OVERLAY_MIN_VISIBLE_MS = 250;
const HOME_INITIAL_OVERLAY_POST_STABLE_DELAY_MS = 500;
const HOME_LAYOUT_STABLE_FRAMES = 3;

const snapScrollTo = (top) => {
	try {
		window.scrollTo({ top, left: 0, behavior: "instant" });
	} catch (error) {
		window.scrollTo(0, top);
	}
};

const Homepage = () => {
	const AuthState = useSelector((state) => state.Auth);
	const HomeState = useSelector((state) => state.Home);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const navigationType = useNavigationType();
	const [loading, setLoading] = useState(() => Boolean(localStorage.getItem("lastPlayReqGameId")));
	usePageMeta({ title: "Akedo | Free Web Games", path: "/" });
	const [isRestoringScroll, setIsRestoringScroll] = useState(() => {
		return navigationType === "POP" && sessionStorage.getItem(HOME_PENDING_SCROLL_RESTORE_KEY) === "1";
	});
	const [isInitialHomeStabilizing, setIsInitialHomeStabilizing] = useState(false);
	const [canShowDeferredHomeContent, setCanShowDeferredHomeContent] = useState(false);
	const scrollRestoreAttemptsRef = useRef(0);

	// const { isWeb3Login } = AuthState;
	const isLoggedIn = Boolean(AuthState?.user && AuthState?.token);
	// const [, updateState] = useState();
	// const forceUpdate = useCallback(() => updateState({}), []);
	// const { address } = useAccount();
	// const { disconnect } = useDisconnect();

	useEffect(() => {
		if (HomeState?.loaded && window.location?.search === "?dl=profile" && isLoggedIn) {
			dispatch(fetchBalanceAuthAction({}));
			navigate(`/`);
		}
	}, [dispatch, navigate, HomeState?.loaded, isLoggedIn]);

	
	const navigateToGame =()=>{
		const lastPlayReqGameId = localStorage.getItem("lastPlayReqGameId");

		const callbackFun =()=>{
			localStorage.removeItem("lastPlayReqGameId"); 
			navigate(`/play/${lastPlayReqGameId}`);
		}
		const handleParticipationReject = (res)=>{		
		}
		
		dispatch(checkGameParticipationAction({app_id:lastPlayReqGameId},callbackFun,handleParticipationReject)) 		
	}

	useEffect(() => {
		if (isLoggedIn) {
			const lastPlayReqGameId = localStorage.getItem("lastPlayReqGameId");
			if (lastPlayReqGameId) {				
				dispatch(fetchGameAppDataAction({app_id:lastPlayReqGameId},navigateToGame))				
			}
		}
	}, [navigate, dispatch, isLoggedIn]);


	// DEPRECATED: Wallet connect flow — kept for future reference, do not delete
	// useEffect(() => {
	// 	const web3Token = localStorage.getItem("web3-token");
	// 	// if address is found but web3Token is not found we try to connect
	// 	if (address && !web3Token) {
	// 		const payload = {
	// 			token: "",
	// 			wallet: address,
	// 			wallet_type: "metamask",
	// 			extra: {},
	// 			failureCallback: disconnect
	// 		};
	// 		const successCallback = () => {
	// 			dispatch(LoadHomDataAction());
	// 			forceUpdate();
	// 		};
	// 		dispatch(ConnectAction(payload, successCallback));
	// 	}
	// }, [address, dispatch, forceUpdate]);

	const videoFilter = (data) => data?.app?.video !== "";
	const bannerVideoDataNew = HomeState?.featured?.filter(videoFilter) || [];
	const homeSections = HomeState?.sections || [];
	const loadedHomeSections = HomeState?.activeSectionViewAll || [];
	const loadedHomeSectionIds = useMemo(() => {
		return new Set(
			loadedHomeSections
				.filter((section) => Array.isArray(section?.items))
				.map((section) => Number(section?.id))
		);
	}, [loadedHomeSections]);
	const searchGames = useMemo(() => {
		const gamesById = new Map();
		const addGame = (game) => {
			if (!game?.id || gamesById.has(game.id)) {
				return;
			}

			gamesById.set(game.id, game);
		};

		(HomeState?.featured || []).forEach((item) => addGame(item?.app));
		(HomeState?.activeSectionViewAll || []).forEach((section) => {
			(section?.items || []).forEach(addGame);
		});

		return Array.from(gamesById.values());
	}, [HomeState?.activeSectionViewAll, HomeState?.featured]);
	const isHomeContentReady = Boolean(HomeState?.loaded)
		&& (homeSections.length === 0 || homeSections.every((section) => loadedHomeSectionIds.has(Number(section?.id))));

	useEffect(() => {
		if (!isHomeContentReady || HomeState?.loading) {
			setCanShowDeferredHomeContent(false);
			return;
		}

		const timer = window.setTimeout(() => {
			setCanShowDeferredHomeContent(true);
		}, 120);

		return () => window.clearTimeout(timer);
	}, [HomeState?.loading, isHomeContentReady]);

	useEffect(() => {
		if (!isInitialHomeStabilizing) {
			return;
		}

		const startedAt = Date.now();
		let frameId = null;
		let postStableTimer = null;
		let lastLayoutHeight = -1;
		let stableFrameCount = 0;
		const maxOverlayTimer = window.setTimeout(() => {
			setIsInitialHomeStabilizing(false);
		}, HOME_INITIAL_OVERLAY_MAX_MS);

		const checkLayoutStability = () => {
			if (!isHomeContentReady) {
				frameId = window.requestAnimationFrame(checkLayoutStability);
				return;
			}

			const layoutHeight = document.documentElement.scrollHeight;
			if (layoutHeight === lastLayoutHeight) {
				stableFrameCount += 1;
			} else {
				stableFrameCount = 0;
				lastLayoutHeight = layoutHeight;
			}

			const minimumVisibleTimePassed = Date.now() - startedAt >= HOME_INITIAL_OVERLAY_MIN_VISIBLE_MS;
			if (minimumVisibleTimePassed && stableFrameCount >= HOME_LAYOUT_STABLE_FRAMES) {
				postStableTimer = window.setTimeout(() => {
					setIsInitialHomeStabilizing(false);
				}, HOME_INITIAL_OVERLAY_POST_STABLE_DELAY_MS);
				return;
			}

			frameId = window.requestAnimationFrame(checkLayoutStability);
		};

		frameId = window.requestAnimationFrame(checkLayoutStability);

		return () => {
			window.clearTimeout(maxOverlayTimer);
			if (frameId) {
				window.cancelAnimationFrame(frameId);
			}
			if (postStableTimer) {
				window.clearTimeout(postStableTimer);
			}
		};
	}, [isHomeContentReady, isInitialHomeStabilizing]);

	useLayoutEffect(() => {
		if (navigationType !== "POP" || sessionStorage.getItem(HOME_PENDING_SCROLL_RESTORE_KEY) !== "1") {
			setIsRestoringScroll(false);
			return;
		}

		const savedScrollY = Number(sessionStorage.getItem(HOME_SCROLL_Y_KEY) || 0);
		if (!savedScrollY) {
			sessionStorage.removeItem(HOME_PENDING_SCROLL_RESTORE_KEY);
			setIsRestoringScroll(false);
			return;
		}

		let cancelled = false;
		let restoreFrame = null;
		let restoreTimeout = null;
		scrollRestoreAttemptsRef.current = 0;

		const restoreScroll = () => {
			if (cancelled) {
				return;
			}

			snapScrollTo(savedScrollY);

			const maxScrollY = Math.max(
				0,
				document.documentElement.scrollHeight - window.innerHeight
			);
			const isContentTallEnough = maxScrollY >= savedScrollY - HOME_SCROLL_RESTORE_TOLERANCE;
			const isRestored = isContentTallEnough && Math.abs(window.scrollY - savedScrollY) <= HOME_SCROLL_RESTORE_TOLERANCE;
			const shouldStop = isRestored || scrollRestoreAttemptsRef.current >= HOME_SCROLL_RESTORE_MAX_ATTEMPTS;

			if (shouldStop) {
				sessionStorage.removeItem(HOME_PENDING_SCROLL_RESTORE_KEY);
				setIsRestoringScroll(false);
				return;
			}

			scrollRestoreAttemptsRef.current += 1;
			restoreFrame = window.requestAnimationFrame(() => {
				restoreTimeout = window.setTimeout(restoreScroll, 50);
			});
		};

		restoreScroll();

		return () => {
			cancelled = true;
			if (restoreFrame) {
				window.cancelAnimationFrame(restoreFrame);
			}
			if (restoreTimeout) {
				window.clearTimeout(restoreTimeout);
			}
		};
	}, [navigationType]);

	useEffect(() => {
		let frameId = null;
		const rememberHomeScroll = () => {
			if (sessionStorage.getItem(HOME_PENDING_SCROLL_RESTORE_KEY) === "1") {
				return;
			}
			if (frameId) {
				return;
			}
			frameId = window.requestAnimationFrame(() => {
				if (sessionStorage.getItem(HOME_PENDING_SCROLL_RESTORE_KEY) === "1") {
					frameId = null;
					return;
				}
				sessionStorage.setItem(HOME_SCROLL_Y_KEY, String(window.scrollY || 0));
				frameId = null;
			});
		};

		rememberHomeScroll();
		window.addEventListener("scroll", rememberHomeScroll, { passive: true });

		return () => {
			if (frameId) {
				window.cancelAnimationFrame(frameId);
			}
			if (sessionStorage.getItem(HOME_PENDING_SCROLL_RESTORE_KEY) !== "1") {
				sessionStorage.setItem(HOME_SCROLL_Y_KEY, String(window.scrollY || 0));
			}
			sessionStorage.setItem(HOME_PENDING_SCROLL_RESTORE_KEY, "1");
			window.removeEventListener("scroll", rememberHomeScroll);
		};
	}, []);

	useEffect(() => {
		if (!loading) return;
		const timer = setTimeout(() => {
			const lastPlayReqGameId = localStorage.getItem("lastPlayReqGameId");
			if (!lastPlayReqGameId) { // if lastPlayReqGameId is not set we can continue is usual and hide the loader
				setLoading(false);
			}
		}, 1000);

		return () => clearTimeout(timer);
	}, [loading]);

	return (
		<div>
			{(loading || isRestoringScroll || isInitialHomeStabilizing) && (
				<div
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						width: "100%",
						height: "100vh",
						backgroundColor: "rgba(0, 0, 0, 1)",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						color: "#fff",
						zIndex: 9999,
					}}
				>
					<EngagingLoader type="bubbles" color="#00e6f4" fullScreen={false} />
				</div>
			)}

			<div style={{ opacity: (loading || isRestoringScroll) ? 0 : 1, transition: "opacity 0.3s" }}>
				<HomeSearch games={searchGames} />
				<VideoBannerComponent isLoggedIn={isLoggedIn} featured={bannerVideoDataNew} isWeb3Login={false /*isWeb3Login*/} />
				<AllGameSectionComponent />
				{canShowDeferredHomeContent && <CategoriesCarousel />}
			</div>
		</div>
	);
};

export default React.memo(Homepage);
